<script setup lang="ts">
import { onMounted, ref } from "vue";
import { fetchCommonDepartmentalList, type CommonDepartmentalChild } from "@/services/common";

const value = defineModel<number>();

interface TreeDataItem {
	title: string;
	key: string | number;
	children?: TreeDataItem[];
}

const normalizeTreeData = (list: CommonDepartmentalChild[]): TreeDataItem[] => {
	return list.map((item) => ({
		title: item.dept_name,
		key: item.dept_id,
		children: item.children?.length ? normalizeTreeData(item.children) : undefined,
	}));
};

const treeData = ref<TreeDataItem[]>([]);

const getTreeData = async () => {
	const res = await fetchCommonDepartmentalList();

	treeData.value = normalizeTreeData(res.data ?? []);
};

onMounted(() => {
	getTreeData();
});
</script>

<template>
	<a-tree-select
		v-model:value="value"
		show-search
		style="width: 100%"
		placeholder="请选择所属部门"
		allow-clear
		tree-default-expand-all
		:tree-data="treeData"
		tree-node-filter-prop="label"
		:fieldNames="{ label: 'title', value: 'key', children: 'children' }"
	></a-tree-select>
</template>
